import { SectorType } from "../models/sector/sector.model";
export var getDefaultWidgetTitle = function (sectorType) {
    switch (sectorType) {
        case SectorType.SPA:
        case SectorType.OTHER:
            return {
                en: 'Find a service',
                de: 'Dienstleistung finden',
                es: 'Buscar servicio',
                it: 'Trova servizio'
            };
        case SectorType.ACCOMMODATION:
            return {
                en: 'Book a room',
                de: 'Zimmer buchen',
                es: 'Reservar una habitación',
                it: 'Prenota una camera'
            };
        case SectorType.RESTAURANT:
            return {
                en: 'Find a table',
                de: 'Tisch finden',
                es: 'Buscar mesa',
                it: 'Trova un tavolo'
            };
        default:
            return {
                en: 'Find a service',
                de: 'Dienstleistung finden',
                es: 'Buscar servicio',
                it: 'Trova servizio'
            };
    }
};
